import { IElementCategory } from '@shared/models/element-categories.model';
import { IConditionalNode } from '../../../helpers/conditional-nodes.helpers';
import {
  IFactorySelectProperty,
  ElementPropertyType,
} from '../../../models/element-property.model';
import {
  MetalPropertyName,
  MetalMaterial,
  Steel,
  SteelStructural,
  Aluminum,
  Copper,
  CopperSheet,
  CopperPipe,
} from './metal.model';
import { commonElementCategoryProperties } from '../common-element-category-properties.model';
import { reusedContentProperty } from '../reused-content-property.model';

const materialProperty: IFactorySelectProperty = {
  name: MetalPropertyName.Material,
  type: ElementPropertyType.Select,
  count: MetalMaterial.Steel,
  options: Object.values(MetalMaterial),
};

const structuralConditionalProperty: IConditionalNode<IFactorySelectProperty> =
  {
    conditions: {
      [MetalPropertyName.Form]: Steel.Structural,
    },
    nodes: [
      {
        name: MetalPropertyName.AmountScrapBased,
        type: ElementPropertyType.Select,
        count: SteelStructural.None,
        options: Object.values(SteelStructural),
        indentation: 1,
      },
    ],
  };

const steelConditionalProperty: IConditionalNode<IFactorySelectProperty> = {
  conditions: {
    [MetalPropertyName.Material]: MetalMaterial.Steel,
  },
  nodes: [
    {
      name: MetalPropertyName.Form,
      type: ElementPropertyType.Select,
      count: Steel.Structural,
      options: Object.values(Steel),
      indentation: 1,
    },
    structuralConditionalProperty,
  ],
};

const profileConditionalProperty: IConditionalNode<IFactorySelectProperty> = {
  conditions: {
    [MetalPropertyName.Form]: Aluminum.Profile,
  },
  nodes: [
    {
      name: MetalPropertyName.AmountScrapBased,
      type: ElementPropertyType.Select,
      options: Object.values(SteelStructural),
      indentation: 1,
    },
  ],
};

const aluminumConditionalProperty: IConditionalNode<IFactorySelectProperty> = {
  conditions: {
    [MetalPropertyName.Material]: MetalMaterial.Aluminum,
  },
  nodes: [
    {
      name: MetalPropertyName.Form,
      type: ElementPropertyType.Select,
      options: Object.values(Aluminum),
      indentation: 1,
    },
    profileConditionalProperty,
  ],
};

const pipeConditionalProperty: IConditionalNode<IFactorySelectProperty> = {
  conditions: {
    [MetalPropertyName.Form]: Copper.Pipe,
  },
  nodes: [
    {
      name: MetalPropertyName.AmountScrapBased,
      type: ElementPropertyType.Select,
      options: Object.values(CopperPipe),
      indentation: 1,
    },
  ],
};

const sheetConditionalProperty: IConditionalNode<IFactorySelectProperty> = {
  conditions: {
    [MetalPropertyName.Form]: Copper.Sheet,
  },
  nodes: [
    {
      name: MetalPropertyName.AmountScrapBased,
      type: ElementPropertyType.Select,
      options: Object.values(CopperSheet),
      indentation: 1,
    },
  ],
};
const copperConditionalProperty: IConditionalNode<IFactorySelectProperty> = {
  conditions: {
    [MetalPropertyName.Material]: MetalMaterial.Copper,
  },
  nodes: [
    {
      name: MetalPropertyName.Form,
      type: ElementPropertyType.Select,
      options: Object.values(Copper),
      indentation: 1,
    },
    pipeConditionalProperty,
    sheetConditionalProperty,
  ],
};

export const metalProperties: IElementCategory['properties'] = [
  materialProperty,
  steelConditionalProperty,
  aluminumConditionalProperty,
  copperConditionalProperty,
  reusedContentProperty,
  ...commonElementCategoryProperties,
];
